export default __webpack_public_path__ + "static/media/grid.009.afa0e3c3.jpeg";